module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<fieldset><legend>'+
((__t=( i18n.tc("VerifyEmail", "Verify new email") ))==null?'':__t)+
'</legend><p>'+
((__t=( i18n.tc("NewPassword", "Please enter your password to verify your new email address.") ))==null?'':__t)+
'</p><div><label for="email-password-input">'+
((__t=( i18n.tc("NewPassword", "Password:") ))==null?'':__t)+
'</label> <input type="password" id="email-password-input" data-input="email-password" required></div><div class="input"><input type="checkbox" id="update-other-emails" data-input="update-other-emails" checked="checked"> <label for="update-other-emails" style="text-align: left; white-space: pre-wrap">'+
((__t=( i18n.tc("NewPassword",
				"Also update invoice and contact email, but only do that if they already had the same email address as the one from which I have now just changed. On the other hand, if these email addresses were not equal to the one you changed from, the email addresses will remain unchanged, and you must go to <em>My Account</em> in order to change them.") ))==null?'':__t)+
'</label></div></fieldset><fieldset class="button-wrap"><button class="primary" data-click="email-submit" disabled="disabled">'+
((__t=( i18n.tc("NewPassword", "Submit") ))==null?'':__t)+
'</button></fieldset>';
}
return __p;
};
